import audienceApi from '@/api/audience'

const createOrUpdateAudienceAction = async ({ commit }, payload) => {
  const audience = await audienceApi.createOrUpdateAudience(payload)
  commit('setAudience', audience)
}
const setAudienceIdAction = ({ commit }, audienceId) => {
  commit('setAudienceId', audienceId)
}

const setQuestionerName = ({ commit }, name) => {
  commit('setQuestionerName', name)
}

export default {
  setAudienceIdAction,
  setQuestionerName,
  createOrUpdateAudienceAction,
}
